// PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

// const PrivateRoute = ({ children, requiredRole }) => {
//   const admintoken = localStorage.getItem('adminToken');
//   const usertoken = localStorage.getItem('userToken');
//   const role = localStorage.getItem('role');

//   // Redirect to home if no token or incorrect role
//   if (!admintoken || !usertoken || !role) {
//     return <Navigate to="/" />;
//   }

//   return children;
// };

export const AdminRoute = ({ children }) => {
    const admintoken = localStorage.getItem('adminToken');
  const usertoken = localStorage.getItem('userToken');
  const role = localStorage.getItem('role');
  if(!role || role !== 'admin'){
    return <Navigate to='/' />
  }
  return children
}

export const UserRoute = ({ children }) => {
  const admintoken = localStorage.getItem('adminToken');
  const usertoken = localStorage.getItem('userToken');
  const role = localStorage.getItem('role');
  if(!role || role !== 'user'){
    return <Navigate to='/' />
  }
  return children
}

// export default PrivateRoute;
